import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import { FormInfoAnalyte } from './FormInfoAnalyte';
import { DeleteInfoAnalyte } from './DeleteInfoAnalyte';
import { Dialog } from 'primereact/dialog';

export const ModalInfoAnlyte = (props) => {

    const {
        modal, modalTitle, toggle, method,
        validaciones,
        name, code, is_interfaced,
        handleInputChange, loading,
        saveCreate, saveUpdate, is_analyte = true
    } = props;

    return (


     <Dialog
        header={modalTitle}
        visible={modal}
        style={{ width: "35rem" }}
        modal
        closable
        appendTo={document.body}  

        onHide={toggle}
                    className="small-dialog"

        headerStyle={{
            backgroundColor: '#0d3b59',
            color: 'white',
            fontWeight: 'bold'
        }}
    >
        {
            method === "create"
                ? <FormInfoAnalyte
                    button={is_analyte ? "Crear analito" : "Crear caracteristica"}
                    {...{ toggle, loading, handleInputChange, validaciones, methodAction: saveCreate, name, code, is_interfaced, is_analyte, method }}
                />
                : (method === "update")
                    ? <FormInfoAnalyte
                        button={is_analyte ? "Editar analito" : "Editar caracteristica"}
                        {...{ toggle, loading, handleInputChange, validaciones, methodAction: saveUpdate, name, code, is_interfaced, is_analyte, method }}
                    />
                    : <DeleteInfoAnalyte
                    />
        }
    </Dialog>
    )
};
